/*
 * SUP-351 — hand-rolled replacement for vue-clickaway's `directive` export.
 * Load-bearing behaviour preserved from the original:
 * - Same-macrotask guard: a `setTimeout(fn, 0)` flips `initialMacrotaskEnded`
 *   only after the click that triggered the bind has finished dispatching,
 *   so that click doesn't immediately close what it just opened (see
 *   Popover.vue's `createPopper()` comment for the other half of this).
 * - "Outside" is computed from the event's `composedPath()` at dispatch time
 *   (falling back to `el.contains`), so an element removed from the DOM
 *   before the event finishes bubbling is still handled correctly.
 * - The callback runs with `this` bound to the directive's owning component
 *   (`vnode.context`), matching `callback.call(vm, ev)`.
 */
const HANDLER = '__clickOutsideHandler';

function unbind(el) {
  if (el[HANDLER]) {
    document.documentElement.removeEventListener('click', el[HANDLER], false);
    delete el[HANDLER];
  }
}

function bind(el, binding, vnode) {
  unbind(el);

  const vm = vnode && vnode.context;
  const callback = binding.value;
  if (typeof callback !== 'function') {
    return;
  }

  let initialMacrotaskEnded = false;
  setTimeout(() => {
    initialMacrotaskEnded = true;
  }, 0);

  el[HANDLER] = (event) => {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : undefined;
    const outside = path ? path.indexOf(el) < 0 : !el.contains(event.target);

    if (initialMacrotaskEnded && outside) {
      callback.call(vm, event);
    }
  };

  document.documentElement.addEventListener('click', el[HANDLER], false);
}

export default {
  bind,
  update(el, binding, vnode) {
    if (binding.value === binding.oldValue) return;
    bind(el, binding, vnode);
  },
  unbind,
};
